var render = function render(_c,_vm){return _c('div',{staticClass:"costs-item"},[_c('img',{staticClass:"costs-item__image",attrs:{"src":_vm.props.image}}),_c('h3',{staticClass:"costs-item__title"},[_vm._v(" "+_vm._s(_vm.props.title)+" ")]),_c('p',{staticClass:"costs-item__content"},[_vm._v(" "+_vm._s(_vm.props.content)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }